import {FiltersModel} from '../interfaces';

export function getDefaultFilters(): FiltersModel {
    return {
        source: [
            {value: 'лп', label: 'Локальный', isSelected: false},
            {value: 'вп', label: 'Веб', isSelected: false}
        ],
        supplier: [],
        ratingRange: {},
        quantityRange: {},
        multiplicityRange: {},
        deliveryDaysRange: {},
        deliveryDateRange: {start: null, end: null},
        isOfficialDealer: false,
        isReturnPossible: false
    };
}
